<mat-form-field appearance="fill" [class.mat-form-field-invalid]="_showValidationError || telInput.invalid">
    <mat-label> {{ _labelData.label }} </mat-label>
    <input matInput type="tel" [name]="_name" [required]="_required" [disabled]="_disabled || _readOnly" #telInput="ngModel"[minlength]="_minLength" [maxlength]="_maxLength" (blur)="onBlur(telInput)" [(ngModel)]="_value" (ngModelChange)="valueUpdated($event)" [pattern]="phoneType === 'mobile' ? '^07[0-9]*$' : '^(?:01|02|03|08)[0-9]*$'"/>
    <mat-icon color="primary" matSuffix>phone</mat-icon>
    @if (_showValidationError || telInput.invalid) {
        <mat-error>{{ errorMessage }}</mat-error>
    }
</mat-form-field>